import type { ContractChangeItemData, ContractChangeStatusEnum, ContractStatusEnum } from 'gql/graphql';
import { Text, Loader } from 'uikit';
import { formatDateToLocale } from 'utils';

import { NavLink } from 'react-router-dom';

import { AgreementsKebabMenu } from '../AgreementsKebabMenu';
import { AgreementsStatus } from '../AgreementsStatus';

export const KebabCellRenderer =
    (
        deleteHandler: ({ id, status }: { id: number; status: ContractChangeStatusEnum }) => void,
        openEditDialogHandler: (id: number, status: ContractChangeStatusEnum) => void,
        handleUploadAgreement: (id: number, status: ContractChangeStatusEnum) => void,
        isDisabledByProjectStatus: boolean,
        statusContract?: ContractStatusEnum,
    ) =>
    // eslint-disable-next-line react/display-name
    ({ value, data }: { value: string | undefined; data: ContractChangeItemData }) => {
        if (data === undefined) {
            return <Loader />;
        }

        return (
            <div className="kebabWrapper">
                <AgreementsKebabMenu
                    currentId={data?.id}
                    currentStatus={data?.status}
                    deleteHandler={deleteHandler}
                    editHandler={openEditDialogHandler}
                    handleUploadAgreement={handleUploadAgreement}
                    isDisabledByProjectStatus={isDisabledByProjectStatus}
                    statusContract={statusContract}
                />
            </div>
        );
    };

export const AgreementsLink = ({ value, data }: { value: string | undefined; data: ContractChangeItemData }) => (
    <NavLink to={`${data?.id}`} style={{ textDecoration: 'none', color: value ? '#000' : 'darkgrey' }}>
        {value || '<Новый>'}
    </NavLink>
);

export const AgreementsStatusRenderer = ({ value }: { value: ContractChangeStatusEnum }) =>
    value ? <AgreementsStatus statusKey={value} /> : '';

export const DateRenderer = ({ value }: { value: string }) => <Text size="s"> {formatDateToLocale(value)}</Text>;

KebabCellRenderer.displayName = 'KebabCellRenderer';
AgreementsStatusRenderer.displayName = 'AgreementsStatusRenderer';
DateRenderer.displayName = 'DateRenderer';
AgreementsLink.displayName = 'AgreementsLink';
